import React, { useState, useEffect } from 'react';
import { Bot, Save, Trash2 } from 'lucide-react';
import { useFirebase } from '../hooks/useFirebase';
import '../App.css';

const TelegramConfig = () => {
  const token = sessionStorage.getItem('token');
  const { telegramConfig, saveTelegramConfig, removeTelegramConfig } = useFirebase(token);
  const [botToken, setBotToken] = useState('');
  const [chatId, setChatId] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Load config from Firebase when it changes
  useEffect(() => {
    if (telegramConfig) {
      setBotToken(telegramConfig.botToken || '');
      setChatId(telegramConfig.chatId || '');
      setEnabled(telegramConfig.enabled || false);
    } else {
      // Clear if config is removed
      setBotToken('');
      setChatId('');
      setEnabled(false);
    }
  }, [telegramConfig]);

  const handleSave = async () => {
    if (!botToken || !chatId) {
      setMessage('Please enter both Bot Token and Chat ID');
      return;
    }

    setLoading(true);
    setMessage('');
    try {
      await saveTelegramConfig({
        botToken,
        chatId,
        enabled
      });
      setMessage('Telegram configuration saved successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message || 'Error saving configuration');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async () => {
    if (!window.confirm('Are you sure you want to remove the Telegram configuration?')) {
      return;
    }

    setLoading(true);
    setMessage('');
    try {
      await removeTelegramConfig();
      setMessage('Telegram configuration removed successfully!');
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.message || 'Error removing configuration');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '30px' }}>
        <Bot size={24} />
        <h2>Telegram Bot Configuration</h2>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600 }}>
          Bot Token
        </label>
        <input
          type="text"
          placeholder="Enter Telegram Bot Token"
          value={botToken}
          onChange={(e) => setBotToken(e.target.value)}
          className="input-field"
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600 }}>
          Chat ID
        </label>
        <input
          type="text"
          placeholder="Enter Chat ID"
          value={chatId}
          onChange={(e) => setChatId(e.target.value)}
          className="input-field"
        />
      </div>

      <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="checkbox"
          id="enabled"
          checked={enabled}
          onChange={(e) => setEnabled(e.target.checked)}
          style={{ width: '20px', height: '20px' }}
        />
        <label htmlFor="enabled" style={{ fontWeight: 600 }}>
          Enable Telegram Notifications
        </label>
      </div>

      {message && (
        <div style={{
          padding: '12px',
          marginBottom: '20px',
          borderRadius: '8px',
          backgroundColor: message.includes('success') ? '#d1fae5' : '#fee2e2',
          color: message.includes('success') ? '#065f46' : '#991b1b',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          {message}
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <button 
          className="action-btn" 
          onClick={handleSave}
          disabled={loading}
          style={{ flex: 1, minWidth: '150px' }}
        >
          <Save size={18} style={{ marginRight: '8px' }} />
          {loading ? 'Saving...' : 'Save Configuration'}
        </button>
        {telegramConfig && (
          <button 
            className="action-btn" 
            onClick={handleRemove}
            disabled={loading}
            style={{ 
              flex: 1, 
              minWidth: '150px',
              backgroundColor: '#ef4444',
              color: 'white'
            }}
          >
            <Trash2 size={18} style={{ marginRight: '8px' }} />
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default TelegramConfig;
